import React from 'react';
import { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AssessmentIcon from '@material-ui/icons/Assessment';
import colors from 'config/colors';
import CommonReportsPage from './CommonReportsPage.jsx';
import FinanceReportPage from './FinanceReportPage.jsx';

export { selectStyle, ScrollTabPanel } from './CommonReportsPage.jsx';

const OUTER_TABS = [
  { key: 'finance-report', label: 'Finance', icon: <MonetizationOnIcon /> },
  { key: 'common-report', label: 'Common', icon: <AssessmentIcon /> },
];

// Reports is split into two independently-owned top-level tabs: Finance (new, this feature) and
// Common (the pre-existing School/Course-Students/Student/Employee reports flow - moved as-is,
// unchanged, into CommonReportsPage.jsx). Kept as a thin switcher rather than folding Finance into
// Common's own internal tab bar so neither flow risks touching the other's state/props wiring -
// Common can be split into its own top-level tabs later with no changes needed here.
// Query tokens that mean "show Common" - its own internal tabs (School/Course-Students/Student/
// Employee) each push one of these, so a bookmarked/shared link into one of those still lands on
// Common with that sub-tab selected. Anything else - including no query at all - defaults to
// Finance now.
const COMMON_TAB_QUERIES = [
  'common-report',
  'school-report',
  'batch-course-students-reports',
  'student-report',
  'employee-report',
];

const ReportsPage = props => {
  const [activeTab, setActiveTab] = useState(() => {
    const search = props.location?.search || '';
    return COMMON_TAB_QUERIES.some(query => search.includes(query)) ? 1 : 0;
  });

  const changeTab = (event, index) => {
    setActiveTab(index);
    if (props.history) {
      props.history.push(`${props.location.pathname}?${OUTER_TABS[index].key}`);
    }
  };

  return (
    <div className="content">
      <Paper square style={{ marginBottom: 16 }}>
        <Tabs
          value={activeTab}
          onChange={changeTab}
          TabIndicatorProps={{ style: { display: 'none' } }}
          textColor="inherit"
          variant="scrollable"
          scrollButtons="on">
          {OUTER_TABS.map((tab, index) => (
            <Tab
              key={tab.key}
              icon={tab.icon}
              label={tab.label}
              style={{
                fontWeight: 'bold',
                color: activeTab === index ? colors.accent : '',
                borderBottom: activeTab === index ? `3px solid ${colors.accent}` : '',
              }}
            />
          ))}
        </Tabs>
      </Paper>
      {activeTab === 0 ? <FinanceReportPage {...props} /> : <CommonReportsPage {...props} />}
    </div>
  );
};

export default ReportsPage;
